const UnitData = [
  {
    id: "#DS0215",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#DS0214",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#DS0212",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#DS0211",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#DS0210",
    date: "06 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#DS0209",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#DS0208",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#DS0207",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#DS0206",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#SK4526",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#SK8522",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#SK4545",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#SK9652",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#SK4256",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#SK4125",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#SK6523",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
  {
    id: "#SK6563",
    date: "09 Oct, 2021",
    unit_name:"Unit 1 - Breast surgery",
    Action: "View Details",
  },
];

export { UnitData };
